export default __webpack_public_path__ + "static/media/new-materials-panel.db27f2e4.png";